module.exports = __webpack_public_path__ + "img/agricultural-sciences.cfdcb320.svg";